import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { PmDialogComponent } from '@shared/components/pm-dialog/pm-dialog.component';
import {
  LocalStorageService,
  LOCAL_STORAGE_ITEMS,
} from '@shared/services/local-storage.service';
import { PmButtonComponent } from '@shared/components/pm-button/pm-button.component';
import { GlobalProperties } from '@shared/models/classes/GlobalProperties';
import { PmFormComponent } from '@shared/components/pm-form/pm-form.component';
import { COOKIES_FORM_CONFIG } from './cookiesForm.config';
import { CommonModule } from '@angular/common';
import { CookiesDialogService } from './cookies-dialog.service';
import { PmLinkComponent } from '@shared/components/pm-link/pm-link.component';
import { RouterLink } from '@angular/router';

interface ICookiesForm {
  cookies: {
    required_cookies: boolean;
    analytics_cookies: boolean;
  };
}

@Component({
  selector: 'pm-cookies-dialog',
  imports: [
    PmDialogComponent,
    PmButtonComponent,
    PmFormComponent,
    CommonModule,
    PmLinkComponent,
    RouterLink,
  ],
  templateUrl: './pm-cookies-dialog.html',
  styleUrl: './pm-cookies-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PmCookiesDialog extends GlobalProperties implements AfterViewInit {
  readonly isCookiesSettingsFormVisible = signal(false);
  readonly config = COOKIES_FORM_CONFIG;
  @ViewChild('cookiesSettingsForm') cookiesSettingsForm!: PmFormComponent;
  @Output() settingsSaved = new EventEmitter();

  readonly isDialogOpen = computed(() =>
    this._cookiesDialogService.isCookiesDialogOpen()
  );

  constructor(
    private _localStorageService: LocalStorageService,
    private _cookiesDialogService: CookiesDialogService
  ) {
    super();
  }

  ngAfterViewInit(): void {
    this._checkShouldOpenCookiesDialog();
  }

  private _checkShouldOpenCookiesDialog() {
    const areCookiesAccepted = !!this._localStorageService.getItem(
      LOCAL_STORAGE_ITEMS.REQUIRED_COOKIES_ACCEPTANCE_STATUS
    );
    if (areCookiesAccepted) return;
    this._cookiesDialogService.setIsCookiesdialogOpen(true);
  }

  onSave() {
    this.cookiesSettingsForm.onSubmit();
  }

  onFormSubmit(values: ICookiesForm) {
    this._localStorageService.setItem(
      LOCAL_STORAGE_ITEMS.REQUIRED_COOKIES_ACCEPTANCE_STATUS,
      values.cookies.required_cookies
    );
    this._localStorageService.setItem(
      LOCAL_STORAGE_ITEMS.ANALYTICS_COOKIES_ACCEPTANCE_STATUS,
      values.cookies.analytics_cookies
    );
    this._cookiesDialogService.setIsCookiesdialogOpen(false);
    this.settingsSaved.emit();
  }

  openSettings() {
    this.isCookiesSettingsFormVisible.set(!this.isCookiesSettingsFormVisible());
  }
}
